const tags = {
  "tag.all": "All",
  "tag.drill": "Drills",
  "tag.bronze_league": "Bronze League",
  "tag.silver_league": "Silver League",
  "tag.gold_league": "Gold League",
  "tag.champions_league": "Champions League",
  "tag.bootcamp": "Bootcamp",
  "tag.qa": "QA",
  "tag.development": "Development",
  "tag.beta_content": "Beta Content",
  "tag.demo": "Trial",
};

export default tags;
